<div class="flex flex-col justify-center items-center p-8 text-xl gap-10">
	<div class="flex justify-center">
		<img
			class="w-64"
			src="/assets/images/leap/update-leap-reminder.png"
			alt="Update to latest version of LEAP"
		/>
	</div>
	<div class="flex flex-col items-center gap-4">
		<h1 class="text-3xl font-medium m-0">Make Sure LEAP Is Up To Date</h1>
		<p class="text-center font-normal text-base">
			For full access to Closer’s tools, LEAP must be on the latest version.
			Please contact your admin to upgrade before continuing.
		</p>
	</div>
</div>
